<template>
  <div v-if="invalidFieldsLabels.length > 0" class="row mt-5 my-3 mb-2">
    <div class="col-12">
      <p class="text-danger">
        Invalid Fields: {{ invalidFieldsLabels.join(", ") }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  invalidFieldsLabels: {
    type: Array as () => string[],
    required: true,
  },
});
</script>
<style lang="scss" scoped></style>
